function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.sq = window.sq || {};

window.addEventListener("load", () => {
  if (window.matchMedia("(max-width: 767px)").matches) {
    document
      .getElementById("Search-In-Modal")
      .addEventListener("focusin", () => {
        document.querySelector(".sq-dropdown-body").style.maxHeight = "100%";
      });
    document
      .getElementById("Search-In-Modal")
      .addEventListener("focusout", () => {
        document.querySelector(".sq-dropdown-body").style.maxHeight = "0px";
      });
  }
});

window.sq.initSearch = (store) => {
  store.search();
};

setTimeout(() => {
  if (document.querySelector(".sq-filter-main"))
    document.querySelector(".sq-filter-main").style.visibility = null;
  if (document.querySelector(".sparq-container"))
    document.querySelector(".sparq-container").style.visibility = null;
}, 200);

window.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    document.querySelector("footer").click();
  }
});
window.sq.handleSuccess = () => {
  // Open and refresh the quick cart
  window.Shopify.theme.sections.instances[3].openQuickCart();
  window.Shopify.theme.sections.instances[3].refreshQuickCart();

  // Fetch cart data
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET'
  })
  .then(response => response.json())
  .then(data => {
    window.theme.cartData = data;
    console.log(data.item_count); // Logs the item count to console

    // Step 1: Create or update the <span> element for 'header__icon-with-label-touch-icon' class
    var iconElement = document.querySelector('.header__icon-with-label-touch-icon');
    if (iconElement) {
      // Check if the span already exists
      var spanElement = iconElement.querySelector('.header__cart-link-count');
      
      // If the span doesn't exist, create it
      if (!spanElement) {
        spanElement = document.createElement('span');
        spanElement.classList.add('header__cart-link-count');
        iconElement.appendChild(spanElement);
      }
      
      // Update the innerHTML of the span with the item_count from cartData
      if (window.theme && window.theme.cartData && typeof window.theme.cartData.item_count !== 'undefined') {
        var itemCount = window.theme.cartData.item_count;
        spanElement.innerHTML = itemCount; // Set the innerHTML to the item_count value
      } else {
        console.error('item_count is not available in cartData.');
      }
    } else {
      console.error('Element with class "header__icon-with-label-touch-icon" not found.');
    }

    // Step 2: Update the 'data-cart-count' attribute for the 'header__icon-with-label-touch-label' class
    var labelElement = document.querySelector('.header__icon-with-label-touch-label');
    if (labelElement) {
  // Update the data-cart-count attribute with the item_count value
  if (window.theme && window.theme.cartData && typeof window.theme.cartData.item_count !== 'undefined') {
    var itemCount = window.theme.cartData.item_count;

    // Set the data-cart-count to item_count
    labelElement.setAttribute('data-cart-count', itemCount);

    // Format the total price using the currency code from Shopify
    var totalPrice = window.theme.cartData.total_price; // The total price in cents
    var currencyCode = window.Shopify.currency; // Get the currency code (e.g., "EUR", "USD")

    // Format the total price using Intl.NumberFormat
    var formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: "EUR"
    }).format(totalPrice / 100); // Divide by 100 to convert cents to actual currency

    // Update the innerHTML with the formatted price
    labelElement.innerHTML = formattedPrice.replace('.',','); // The formatted price will include the symbol and correct formatting

  } else {
    console.error('item_count is not available in cartData.');
  }
} else {
  console.error('Element with class "header__icon-with-label-touch-label" not found.');
}

  })
  .catch(error => {
    console.error('Error fetching cart data:', error);
  });
}

